import { render, staticRenderFns } from "./WorkspaceSigChainMatrix.vue?vue&type=template&id=3de34cc3&scoped=true"
import script from "./WorkspaceSigChainMatrix.vue?vue&type=script&lang=js"
export * from "./WorkspaceSigChainMatrix.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSigChainMatrix.vue?vue&type=style&index=0&id=3de34cc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de34cc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de34cc3')) {
      api.createRecord('3de34cc3', component.options)
    } else {
      api.reload('3de34cc3', component.options)
    }
    module.hot.accept("./WorkspaceSigChainMatrix.vue?vue&type=template&id=3de34cc3&scoped=true", function () {
      api.rerender('3de34cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceSigChainMatrix.vue"
export default component.exports